// initial state
const state = () => ({
  users: [],
  totalUsers: 0,
  currentPage: 1,
  perPage: 25,
  sort: "desc",
  sortBy: "userid",
  loading: false,
  error: null,
  searchKeyword: "",
});

// getters
const getters = {
  users: (state) => state.users,
  totalUsers: (state) => state.totalUsers,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  sort: (state) => state.sort,
  sortBy: (state) => state.sortBy,
  loading: (state) => state.loading,
  error: (state) => state.error,
  searchKeyword: (state) => state.searchKeyword,
};

// actions
const actions = {
  setUsers({ commit }, users) {
    commit("SET_USERS", users);
  },
  setTotalUsers({ commit }, total) {
    commit("SET_TOTAL_USERS", total);
  },
  setCurrentPage({ commit }, page) {
    commit("SET_CURRENT_PAGE", page);
  },
  setPerPage({ commit }, perPage) {
    commit("SET_PER_PAGE", perPage);
  },
  setSort({ commit }, sort) {
    commit("SET_SORT", sort);
  },
  setSortBy({ commit }, sortBy) {
    commit("SET_SORT_BY", sortBy);
  },
  setLoading({ commit }, loading) {
    commit("SET_LOADING", loading);
  },
  setError({ commit }, error) {
    commit("SET_ERROR", error);
  },
  setSearchKeyword({ commit }, keyword) {
    commit("SET_SEARCH_KEYWORD", keyword);
  },
  clearUsers({ commit }) {
    commit("CLEAR_USERS");
  },
};

// mutations
const mutations = {
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_TOTAL_USERS(state, total) {
    state.totalUsers = total;
  },
  SET_CURRENT_PAGE(state, page) {
    state.currentPage = page;
  },
  SET_PER_PAGE(state, perPage) {
    state.perPage = perPage;
  },
  SET_SORT(state, sort) {
    state.sort = sort;
  },
  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_SEARCH_KEYWORD(state, keyword) {
    state.searchKeyword = keyword;
  },
  CLEAR_USERS(state) {
    state.users = [];
    state.totalUsers = 0;
    state.currentPage = 1;
    state.perPage = 25;
    state.sort = "desc";
    state.sortBy = "userid";
    state.loading = false;
    state.error = null;
    state.searchKeyword = "";
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
